
import { mapState, mapGetters } from 'vuex';
import { pathWithParams } from '@/lib/params';
import ReviewSort from '@/enums/ReviewSort';
import TransitionExpand from '@/transitions/TransitionExpand';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';
import AiIconType from '@/enums/AiIconType';

export default {
  name: 'AppFilterSectionSearchBar',
  components: { TransitionExpand },
  props: {
    params: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      selectedSortType: ReviewSort.RECENTLY_CREATED,
      isMediaReviewsFirstChecked: false,
      enableSearchButton: false,
      searchInput: null,
      isSubmitStatus: false
    };
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('window', ['windowService']),
    ...mapState('review', ['hasMedia']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('widget', ['displayMediaReviewsFirstToggleListV3']),
    DropdownMenuWidth: () => DropdownMenuWidth,
    ReviewSort: () => ReviewSort,
    aiIconName() {
      return this.reviewSettings.ai_icon_type === AiIconType.CUSTOM
        ? 'icon-ai-solid'
        : 'icon-ai-gradation';
    },
    displayOrderOptions() {
      return this.widget.display_orders_in_use.map(order => ({
        value: order,
        name: ReviewSort.t(order),
        leadingAiIconName:
          order === ReviewSort.AI_RECOMMENDATION ? this.aiIconName : null
      }));
    },
    selectedOptionLabel() {
      const selectedOption = this.displayOrderOptions.find(
        o => o.value === this.selectedSortType
      );
      return selectedOption ? selectedOption.name : '';
    },
    isMediaReviewsFirst() {
      return (
        this.isMediaReviewsFirstChecked || this.widget.review_show_photo_first
      );
    }
  },
  watch: {
    params(newParams, oldParams) {
      this.syncFilterStateFromParams();
      if (newParams.query !== oldParams.query) this.syncSearchStateFromParams();
    }
  },
  created() {
    this.syncFilterStateFromParams();
    this.syncSearchStateFromParams();
  },
  methods: {
    syncSearchStateFromParams() {
      this.searchInput = this.params.query || null;
    },
    syncFilterStateFromParams() {
      const { media_reviews_first, sort } = this.params;
      this.selectedSortType = parseInt(sort || this.widget.display_order);
      this.isMediaReviewsFirstChecked = media_reviews_first
        ? JSON.parse(media_reviews_first) || false
        : false;
    },
    openReviewSortDialog() {
      const reviewSortPath = pathWithParams(
        `${window.location.origin}/v2/review_sort`,
        {
          display_orders_in_use: this.widget.display_orders_in_use,
          media_reviews_first: this.isMediaReviewsFirst
        }
      );
      this.windowService.openFullscreenPopup(reviewSortPath);
    },
    enableSearch(enable) {
      this.enableSearchButton = enable;
      if (this.enableSearchButton) {
        this.$nextTick(() => {
          this.$refs.search_input.focus();
        });
      }
    },
    enterSearchInput() {
      if (this.enableSearchButton) {
        this.submitSearchInput();
        this.$nextTick(() => this.$refs.search_input.focus());
      }
    },
    submitSearchInput() {
      this.isSubmitStatus = this.searchInput?.length > 0;
      this.$emit('submit', { query: this.searchInput });
    }
  }
};
